<div class="d-flex" (click)="$event.stopPropagation()">
  <f-list [withConcisedItems]="true" class="f-collapsed-popover-list">
    <f-list-item-concised *ngFor="let item of itemsRef" (removeItem)="onRemove(item)" [danger]="isItemInvalid(item)">
      <div
        (click)="onItemClick(item)"
        class="text-truncate w-100"
        [ngClass]="itemCssClassRef"
        title="{{ item | fNestedValue : valuePathRef }}"
        *ngIf="!(item | fNestedValue : linkPathRef)"
        data-automation-id="list-group-item-content"
      >
        {{ item | fNestedValue : valuePathRef }}
      </div>
      <a
        *ngIf="item | fNestedValue : linkPathRef"
        data-automation-id="list-group-item-content"
        class="link link-main text-truncate"
        [href]="item | fNestedValue : linkPathRef"
        title="{{ item | fNestedValue : valuePathRef }}"
        target="_blank"
        >{{ item | fNestedValue : valuePathRef }}</a
      >
      @let subCategory = item | fNestedValue : subCategoryPathRef; @if (subCategory) {
      <div class="body-50 text-muted text-truncate" title="{{ subCategory }}">
        {{ subCategory }}
      </div>
      }
    </f-list-item-concised>
  </f-list>
</div>
